import React, {SVGProps} from 'react';

import {ReactComponent} from '../../assets/svg/delete_outline.svg';

export default (props: SVGProps<any>) => <ReactComponent {...props} />;
